import React from "react"
import PropTypes from "prop-types"
import Markdown from 'react-markdown'
import rehypeHighlight from "rehype-highlight";
// import "highlight.js/styles/atom-one-dark.css";
import 'github-markdown-css/github-markdown.css'; // 引入 GitHub 样式
import "./Markdown.css"
// import remarkGfm from 'remark-gfm';
// import remarkBreaks from 'remark-breaks';
import { marked } from 'marked'; // 使用命名导入而不是默认导入
import { Typography } from "@mui/material";

const isHTML = (str) => /<\/?[a-z][\s\S]*>/i.test(str);
const isMarkdown = (str) => {
    try {
        marked.parse(str); // 尝试解析 Markdown
        return true;
    } catch (error) {
        return false;
    }
};
const getContentType = (content) => {
    if (isHTML(content)) return 'html';
    if (isMarkdown(content)) return 'markdown';
    return 'text';
};
const GridTextComponent = React.memo((props) => {

    const { value, position } = props;
    const contentType = getContentType(value);

    if (contentType === "html") {
        return <div className="html-content" dangerouslySetInnerHTML={{ __html: value }} />
    }
    if (contentType === "markdown") {
        return (
            <div className="markdown-body">

                <Markdown
                    components={{ a: ({ node, ...props }) => (<a {...props} target="_blank" rel="noopener noreferrer" />) }}
                    children={value}
                    rehypePlugins={[rehypeHighlight]}
                    // remarkPlugins={[remarkGfm, remarkBreaks]}
                    // className="prose prose-zinc max-w-2xl dark:prose-invert markdown-content"
                    className={`prose ${position} prose-zinc max-w-2xl dark:prose-invert markdown-content`}
                />
            </div>
        )
    }
    if (contentType === "text") {
        return (<Typography sx={{ whiteSpace: "pre-wrap" }}>{value}</Typography>);
    }
    return "";
});
GridTextComponent.propTypes = {
    value: PropTypes.any,
    position: PropTypes.any
}
export default GridTextComponent;